<lui-floating-panel [opened]="floatingPanelOpened" [color]="color">
  <ng-content buttonIcon select="[luiFloatingPanelIcon]"></ng-content>
  <ng-content select="[luiFloatingPanel]"></ng-content>
</lui-floating-panel>

<lui-scroll-top
  *ngIf="!scrollTopDisabled"
  [offset]="scrollOffset"
  (scrolled)="scrolled.emit()"
  class="d-flex ms-1"
></lui-scroll-top>
